// Confirmação de quem está usando o app antes de uma ação grave (0.47): biometria, se estiver ligada,
// ou a senha da conta. Ex.: excluir um fichário inteiro da aba Estudos.
// 0.66: aceita também o código/PIN/padrão do próprio aparelho (A5) e pode ter título, texto e botão próprios (B6).
import { useRef, useState } from 'react';
import { Alert, Modal, Platform, Pressable, Text, View } from 'react-native';
import { useAuth, semBloqueio } from '../auth/AuthContext';
import { Field } from './ui';
import { C } from './theme';
import { t } from '../lib/i18n';

export type OpcoesConfirmar = { titulo?: string; texto?: string; botao?: string; perigo?: boolean; semBiometriaDireta?: boolean };

export function useConfirmarIdentidade(cor: string) {
  const { conferirSenha, bio, bioDisponivel } = useAuth();
  const [pedido, setPedido] = useState<(OpcoesConfirmar & { motivo: string }) | null>(null);
  const [senha, setSenha] = useState('');
  const resolver = useRef<((ok: boolean) => void) | null>(null);

  const aparelho = async (motivo: string) => {
    try {
      const LA = require('expo-local-authentication');
      const r = await semBloqueio(() => LA.authenticateAsync({ promptMessage: motivo, promptDescription: t('Use a biometria ou o código/PIN/padrão do dispositivo.') })) as { success: boolean };
      return !!r.success;
    } catch { return false; }
  };

  const pedir = async (motivo: string, op: OpcoesConfirmar = {}): Promise<boolean> => {
    if (Platform.OS !== 'web' && bio && !op.semBiometriaDireta && (await aparelho(motivo))) return true;
    setSenha('');
    setPedido({ motivo, ...op });
    return new Promise<boolean>(res => { resolver.current = res; });
  };
  const fim = (ok: boolean) => { setPedido(null); setSenha(''); resolver.current?.(ok); resolver.current = null; };
  const confirmar = async () => {
    if (await conferirSenha(senha)) fim(true);
    else Alert.alert(t('Senha incorreta.'), t('Confira a senha da sua conta e tente de novo.'));
  };
  const pelaBio = async () => { if (pedido && (await aparelho(pedido.titulo ?? pedido.motivo))) fim(true); };

  const corBotao = pedido?.perigo ? C.danger : cor;
  const tela = (
    <Modal visible={!!pedido} transparent animationType="fade" onRequestClose={() => fim(false)}>
      <View style={{ flex: 1, backgroundColor: C.overlay, justifyContent: 'center', padding: 24 }}>
        <View style={{ backgroundColor: C.card, borderRadius: 18, padding: 18, gap: 12 }}>
          <Text style={{ color: C.text, fontWeight: '800', fontSize: 17 }}>{pedido?.perigo ? '' : '🔒 '}{pedido?.titulo ?? pedido?.motivo}</Text>
          <Text style={{ color: C.sub, fontSize: 13 }}>{pedido?.texto ?? t('Para continuar, digite a senha do app ou use a biometria/o código do dispositivo.')}</Text>
          <Field value={senha} onChangeText={setSenha} secureTextEntry autoFocus placeholder={t('Senha do app')} onSubmitEditing={confirmar} />
          {Platform.OS !== 'web' && bioDisponivel && (
            <Pressable onPress={pelaBio} style={{ paddingVertical: 6 }}><Text style={{ color: cor, fontWeight: '700' }}>📱 {t('Biometria ou código do dispositivo')}</Text></Pressable>
          )}
          <View style={{ flexDirection: 'row', gap: 10, justifyContent: 'flex-end' }}>
            <Pressable onPress={() => fim(false)} style={{ padding: 10 }}><Text style={{ color: C.sub }}>{t('Cancelar')}</Text></Pressable>
            <Pressable onPress={confirmar} disabled={!senha} style={{ backgroundColor: senha ? corBotao : C.mute, borderRadius: 10, paddingHorizontal: 16, paddingVertical: 10 }}>
              <Text style={{ color: '#fff', fontWeight: '700' }}>{pedido?.botao ?? t('Confirmar')}</Text></Pressable>
          </View>
        </View>
      </View>
    </Modal>
  );
  return { pedir, tela };
}
